<template>
  <section>
    <Navigation />
    <div class="wrapper">
      <SignIn />
    </div>
  </section>
</template>

<script>
import SignIn from './Signin';
import Navigation from '@/components/Navigations/PublicNavigation';

export default {
  components: {
    SignIn,
    Navigation,
  },
};
</script>

<style lang="scss" scoped>
section {
  .wrapper {
    padding: 20px;
  }
}
</style>
